import React from 'react'
import { Box, Typography, useMediaQuery } from '@material-ui/core'
import { useIntl } from 'gatsby-plugin-intl'
import { useStyles } from './ProductInfo.style'
import { resolveImageUrlForDeviceAndLocale } from '../../utils/resolveImageUrlForDeviceAndLocale'

const ProductInfoVariationSixtyAfterSales = (props) => {
  const styles = useStyles()
  const { locale } = useIntl()
  const { t } = props

  const isDesktop = useMediaQuery((theme) => theme.breakpoints.up('sm'))

  return (
    <Box
      className={[
        styles.sixtyVariantRoot,
        props.subType === 'cta' && styles.ctaVariantRoot,
        styles.sixtyVariantAfterSalesRoot,
      ].join(' ')}
    >
      {' '}
      <Box
        className={styles.variantImageAfterSales}
        style={{ width: props.customWidth ? props.customWidth : '200px' }}
      >
        <Typography variant="h1" className={styles.fortyVariantTitleAfterSales}>
          {t(props.title)}
        </Typography>
        {props.imageUrl ? (
          <img
            src={resolveImageUrlForDeviceAndLocale(
              props.imageUrl,
              locale,
              isDesktop,
              props.imageShouldSwitchLocale,
            )}
          />
        ) : (
          props.icon
        )}
      </Box>
    </Box>
  )
}

export default ProductInfoVariationSixtyAfterSales
